"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.intro.start': 'Inizia Onboarding',
    'onboarding.intro.optimize': 'Ottimizza Operazioni e Processi',
    'onboarding.intro.moment': 'È giunto il momento per l\'implementazione strategica di Assistenti IA avanzati.',
    'onboarding.intro.enables': 'Il loro uso nell\'azienda permette:',
};
